import { env } from '../../lib/env/env';

export const connectConfig = {
  CONNECT_URL: env.getString('CONNECT_URL') || 'http://localhost:5000',
};
